module.exports = __webpack_public_path__ + "media/application/images/svgs/divide-5570f48d84dff7264aedec91203308cb.svg";